var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m106.45,311.55c0,3.21,1.25,6.22,3.51,8.48,2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.49-3.52l88.06-88.06,88.06,88.06c2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.48-3.51c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.52-8.48l-88.06-88.06,88.06-88.06c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.51-8.48c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.48,3.52l-88.06,88.06-88.06-88.06c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.49,3.51-3.52,5.28-3.52,8.49,1.25,6.22,3.51,8.48l88.06,88.06-88.06,88.06c-2.27,2.27-3.52,5.28-3.52,8.49Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b36fa1d28736fb3ce82e9808e8165eda.svg";
export { ForwardRef as ReactComponent };